import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=163335d0&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.css?vue&type=style&index=0&id=163335d0&prod&scoped=true&lang=css&external"
import style1 from "./Index.vue?vue&type=style&index=1&id=163335d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163335d0",
  null
  
)

export default component.exports